import ReferenceSelectorPreviewController from './reference-selector-preview.controller';
import { ReferenceSelectorPreviewProps } from './reference-selector-preview.model';

const ReferenceSelectorPreview = (props: ReferenceSelectorPreviewProps) => {
  return <ReferenceSelectorPreviewController {...props} />;
};

export default ReferenceSelectorPreview;
